<template>
    <Headify :data="headMeta" />
    <main class="flex min-h-screen flex-1 flex-col justify-center">
        <div class="mx-auto w-full max-w-xl px-2 pt-12 sm:px-4 md:pt-4">
            <div class="space-y-6 py-6">
                <AlertBox
                    state="danger"
                    :icon="MdiAlert"
                    :title="t('error404')"
                >
                    <p class="py-1 text-sm">{{ t('error404Text') }}</p>
                    <p class="py-1 text-right text-sm font-medium">
                        <a
                            :href="returnUrl"
                            class="dark:hover-red-300 hover:text-red-400"
                        >
                            <MdiArrowLeft class="mr-px inline h-4 w-4" />
                            {{ t('backHome') }}
                        </a>
                    </p>
                </AlertBox>
            </div>
        </div>
    </main>
</template>

<script setup>
    import { useRoute } from 'vue-router';
    import navs from '../composables/navs';
    import Headify from '../components/Headify.vue';
    import AlertBox from '../ui/AlertBox.vue';
    import { MdiAlert, MdiArrowLeft } from 'materialdesignicons-vue3/icons/';

    const route = useRoute();
    const returnUrl = '/';
    const headMeta = navs().metaFind(route.name);
</script>
